import UserDriverListRequest, {
  UserDriverListRequestStatusCriteria,
  UserDriverListRequestOrder,
} from "../../../../api/raily/user/driver/list/user-driver-list.request";
import UserStatus from "../../../../types/user-status";
import paginationService from "../../../../utils/pagination/pagination.service";
import UserDriverListParams, {
  UserDriverListParamsOrder,
} from "./user-driver-list-params";

const createStatusCriteria = (
  status: UserStatus | undefined,
): UserDriverListRequestStatusCriteria => {
  switch (status) {
    case UserStatus.ACTIVE:
      return UserDriverListRequestStatusCriteria.ACTIVE;
    case UserStatus.DELETED:
      return UserDriverListRequestStatusCriteria.DELETED;
    default:
      return UserDriverListRequestStatusCriteria.ALL;
  }
};

const createOrder = (
  status: UserDriverListParamsOrder | undefined,
): UserDriverListRequestOrder | undefined => {
  switch (status) {
    case UserDriverListParamsOrder.FIRST_NAME_ASC:
      return UserDriverListRequestOrder.FIRST_NAME_ASC;
    case UserDriverListParamsOrder.FIRST_NAME_DESC:
      return UserDriverListRequestOrder.FIRST_NAME_DESC;
    case UserDriverListParamsOrder.LAST_NAME_ASC:
      return UserDriverListRequestOrder.LAST_NAME_ASC;
    case UserDriverListParamsOrder.LAST_NAME_DESC:
      return UserDriverListRequestOrder.LAST_NAME_DESC;
    case UserDriverListParamsOrder.TAXI_CORPORATION_DISPLAY_NAME_ASC:
      return UserDriverListRequestOrder.TAXI_CORPORATION_DISPLAY_NAME_ASC;
    case UserDriverListParamsOrder.TAXI_CORPORATION_DISPLAY_NAME_DESC:
      return UserDriverListRequestOrder.TAXI_CORPORATION_DISPLAY_NAME_DESC;
    case UserDriverListParamsOrder.LAST_PLAN_ENTRY_END_TIME_ASC:
      return UserDriverListRequestOrder.LAST_PLAN_ENTRY_END_TIME_ASC;
    case UserDriverListParamsOrder.LAST_PLAN_ENTRY_END_TIME_DESC:
      return UserDriverListRequestOrder.LAST_PLAN_ENTRY_END_TIME_DESC;
    case UserDriverListParamsOrder.CREATION_DATE_ASC:
      return UserDriverListRequestOrder.CREATED_AT_ASC;
    case UserDriverListParamsOrder.CREATION_DATE_DESC:
      return UserDriverListRequestOrder.CREATED_AT_DESC;
    case UserDriverListParamsOrder.MODIFICATION_DATE_ASC:
      return UserDriverListRequestOrder.MODIFIED_AT_ASC;
    case UserDriverListParamsOrder.MODIFICATION_DATE_DESC:
      return UserDriverListRequestOrder.MODIFIED_AT_DESC;
    default:
      return undefined;
  }
};

const create = (params: UserDriverListParams): UserDriverListRequest => {
  return {
    address: params.address,
    creationStart: params.creationDateFrom,
    creationEnd: params.creationDateTo,
    modificationEnd: params.modificationDateTo,
    modificationStart: params.modificationDateFrom,
    email: params.email,
    firstName: params.firstName,
    fleetPartner: params.fleetPartner,
    fleetPartnerId: params.fleetPartnerUuid,
    lastName: params.lastName,
    limit: params.pageSize,
    offset: paginationService.calculateOffset(params.page, params.pageSize),
    order: createOrder(params.order),
    pendingCandidature: params.isCandidaturePending,
    statusCriteria: createStatusCriteria(params.status),
    taxiCorporation: params.taxiCorporation,
    taxiCorporationId: params.taxiCorporationUuid,
    username: params.username,
  };
};

const userDriverListParamsFactory = { create };

export default userDriverListParamsFactory;
